import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';

const DashboardQuickActions = () => {
  return (
    <div className='bg-white rounded-xl border border-gray-200 shadow-xs p-5 mb-6 transition-all'>
      <h3 className='text-xs font-bold text-gray-500 uppercase tracking-wider mb-3'>
        Quick Actions
      </h3>

      <div className='grid grid-cols-1 gap-2.5'>
        <Link
          to={ROUTES.TOPUP_CASHBACK}
          className='flex items-center gap-3 p-2.5 rounded-lg border border-gray-200 hover:border-blue-300 hover:bg-blue-50/50 transition-all text-gray-800 hover:text-blue-700 group'
        >
          <div className='w-8 h-8 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center group-hover:bg-blue-600 group-hover:text-white transition-colors'>
            <svg className='w-4 h-4' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
              <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M12 6v6m0 0v6m0-6h6m-6 0H6' />
            </svg>
          </div>
          <div className='flex-1'>
            <div className='text-xs font-bold'>Topup Merchant Balance</div>
            <div className='text-2xs text-gray-400'>Fund marketing cashback pool</div>
          </div>
          <span className='text-gray-300 group-hover:text-blue-500 text-xs'>→</span>
        </Link>

        <Link
          to={ROUTES.USERS}
          className='flex items-center gap-3 p-2.5 rounded-lg border border-gray-200 hover:border-emerald-300 hover:bg-emerald-50/50 transition-all text-gray-800 hover:text-emerald-700 group'
        >
          <div className='w-8 h-8 rounded-lg bg-emerald-50 text-emerald-600 flex items-center justify-center group-hover:bg-emerald-600 group-hover:text-white transition-colors'>
            <svg className='w-4 h-4' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
              <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z' />
            </svg>
          </div>
          <div className='flex-1'>
            <div className='text-xs font-bold'>Invite Admin User</div>
            <div className='text-2xs text-gray-400'>Add team member permissions</div>
          </div>
          <span className='text-gray-300 group-hover:text-emerald-500 text-xs'>→</span>
        </Link>

        <Link
          to={ROUTES.MERCHANTS}
          className='flex items-center gap-3 p-2.5 rounded-lg border border-gray-200 hover:border-purple-300 hover:bg-purple-50/50 transition-all text-gray-800 hover:text-purple-700 group'
        >
          <div className='w-8 h-8 rounded-lg bg-purple-50 text-purple-600 flex items-center justify-center group-hover:bg-purple-600 group-hover:text-white transition-colors'>
            <svg className='w-4 h-4' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
              <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z' />
            </svg>
          </div>
          <div className='flex-1'>
            <div className='text-xs font-bold'>Verify Merchant Partita IVA</div>
            <div className='text-2xs text-gray-400'>Validate business VAT status</div>
          </div>
          <span className='text-gray-300 group-hover:text-purple-500 text-xs'>→</span>
        </Link>
      </div>
    </div>
  );
};

export default DashboardQuickActions;
